import React from 'react';

import './Project.css';

class Project extends React.Component {

    render() {
        const imageReq = require.context("../images", false, /\.png$/);
        const url = imageReq(`./${this.props.obj.image}`);

        var linkClasses = "projectLink";
        if (this.props.obj.link === "") {
            linkClasses +=  " inactive";
        }
        
        return (
            <div className="card">
                <div className="badge-promo">
                    <div className="headRow">
                        <h3 className="font">{this.props.obj.name}</h3>
                        <b>{this.props.obj.createdFor}</b>
                    </div>
                </div>
                <br/>
                <div className="switchRow">
                    <div className="img container" style={{backgroundImage: "url(" + url + ")"}}>

                    </div>
                    <div className="desc container">
                        <h4>Was ist das?</h4><br />
                        <div dangerouslySetInnerHTML={ this.getDescription() }></div>
                    </div>
                    <div className="highlights container">
                        <h4>Was habe ich gemacht?</h4><br />
                        <div dangerouslySetInnerHTML={ this.getHighlights() }></div>
                    </div>
                </div>
                <div className="floorRow">
                    <div className="stackList" dangerouslySetInnerHTML={ this.getStack() }></div> 
                    <a className={linkClasses} href={this.props.obj.link} target="_blank">Zum Projekt <i className="fa fa-chevron-right" aria-hidden="true"></i></a>
                </div>
            </div>
        );
    }

    onHover(args) {
        let elem = args.currentTarget;
        this.props.onHover(elem);
        elem.parentNode.classList.add("toggle");
    }

    getDescription() {
        return {
            __html: this.props.obj.description
        };
    }

    getHighlights() {
        var content = "<ul>";
        this.props.obj.highlights.map((hl, index) => {
            content += "<li key=" + index + ">" + hl + "</li>";
        });
        content += "</ul>";
            

        return {
            __html: content
        }
    }

    getStack() {
        var content = "";
        this.props.obj.stack.map((elem) => {
            content += "<div class='stackItem'>";
            content += elem;
            content += "</div>"; 
        });

        return {
            __html: content
        }
    }
}

export default Project;


// WEBPACK FOOTER //
// ./src/project/Project.react.js